<template>
    <f7-page pull-to-refresh @ptr:refresh="refresh">

        <f7-navbar :title="title" sliding>
            <f7-nav-right>
                <f7-link icon="icon-bars" open-panel="left"></f7-link>
            </f7-nav-right>
        </f7-navbar>


        <div v-if="Order && Order.status === 'PAID'">
            <f7-card form class="green">
                <f7-card-header>{{ $root.__('Your Enrollment Successfully done') }}</f7-card-header>

                <f7-card-content>
                    <f7-grid>
                        <f7-col width="100" :tablet-width="50">
                            <span class="key">{{ $root.__('FName') }}:</span> {{ Order.fname }}
                        </f7-col>
                        <f7-col width="100" :tablet-width="50">
                            <span class="key">{{ $root.__('LName') }}:</span> {{ Order.lname }}
                        </f7-col>
                        <f7-col width="100" :tablet-width="50">
                            <span class="key">{{ $root.__('National Code') }}:</span> {{ Order.national_code }}
                        </f7-col>
                        <f7-col width="100" :tablet-width="50">
                            <span class="key">{{ $root.__('Mobile') }}:</span> {{ Order.mobile }}
                        </f7-col>
                        <f7-col width="100" :tablet-width="50">
                            <span class="key">{{ $root.__('TREF') }}:</span> {{ Order.tref }}
                        </f7-col>
                    </f7-grid>
                </f7-card-content>
            </f7-card>

            <f7-block>
                <f7-grid>
                    <f7-col>
                    </f7-col>
                    <f7-col>
                        <f7-button raised fill color="blue" @click="gotIt">اطلاعات را یادداشت کردم!</f7-button>
                    </f7-col>
                    <f7-col>
                    </f7-col>
                </f7-grid>
            </f7-block>
        </div>


        <div v-if="Order && Order.status !== 'PAID'">
            <f7-card form class="red">
                <f7-card-header>{{ $root.__('Error in Enrollment') }}</f7-card-header>
                <f7-card-content>
                    {{ $root.__('Error in Enrollment Full') }}
                </f7-card-content>
            </f7-card>

            <f7-block>
                <f7-grid>
                    <f7-col></f7-col>
                    <f7-col>
                        <f7-button raised fill color="blue" @click="gotIt">دوباره سعی می کنم!</f7-button>
                    </f7-col>
                    <f7-col></f7-col>
                </f7-grid>
            </f7-block>
        </div>

        <div v-if="Presentation">
            <f7-card form class="bg-teal color-white">

                <f7-card-header>عنوان دوره:
                    {{ $root.farsiFormat(Presentation.course.title) }}
                </f7-card-header>

                <f7-card-content>
                    <f7-grid>
                        <f7-col width="100" :tablet-width="50">
                            <span class="key">{{ $root.__('Id') }}:</span> {{ Presentation.id }}
                        </f7-col>
                        <f7-col width="100" :tablet-width="50">
                            <span class="key">{{ $root.__('Presentation Days') }}:</span> {{ $root.farsiFormat(Presentation.days) }}
                        </f7-col>
                        <f7-col width="100" :tablet-width="50">
                            <span class="key">{{ $root.__('Start Date') }}:</span> {{ $root.farsiFormat(Presentation.start_date_jalali, true) }}
                        </f7-col>
                        <f7-col width="100" :tablet-width="50">
                            <span class="key">{{ $root.__('Number of Hours') }}:</span> {{ $root.farsiFormat(Presentation.duration) }}
                        </f7-col>
                        <f7-col width="100" :tablet-width="50">
                            <span class="key">{{ $root.__('Price(Rial)') }}:</span>
                            <span v-if="Presentation.discount_percent > 0">
                                <span class="changed">{{ $root.farsiFormat(Presentation.price.toLocaleString()) }}</span>
                                <span>{{ $root.farsiFormat(parseInt(Presentation.price - Presentation.price * Presentation.discount_percent / 100).toLocaleString()) }}</span>
                            </span>
                            <span v-else>{{ $root.farsiFormat(Presentation.price.toLocaleString()) }}</span>
                        </f7-col>
                    </f7-grid>
                </f7-card-content>
            </f7-card>

            <f7-card v-if="Presentation.course.prequireds.length > 0" form class="orange prequireds">
                <f7-card-header>{{ $root.__('Prequireds') }}</f7-card-header>
                <f7-card-content>
                    <f7-list>
                        <f7-list-item v-for="Prequired in Presentation.course.prequireds">
                            {{ $root.farsiFormat(Prequired.title) }}
                        </f7-list-item>
                    </f7-list>
                </f7-card-content>
            </f7-card>
        </div>

    </f7-page>
</template>

<script>
    export default {
        data: function () {
            let self = this;

            return {
                title: self.$root.__('Register in Presentation'),
                presentation_id: 0,
                order_id: 0
            }
        },
        computed: {
            Presentation: function () {
                let self = this;

                return self.$store.getters.item('Presentations', self.presentation_id);
            },
            Order: function () {
                let self = this;

                return self.$store.getters.item('Orders', self.order_id);
            }
        },
        methods: {
            refresh: function () {

            },
            gotIt: function () {
                let self = this;

                let ls = JSON.parse(localStorage.getItem('mftsk-lms')) || {};
                ls.redirect = '';
                localStorage.setItem('mftsk-lms', JSON.stringify(ls));

                window.location = self.$store.state._wordpress_url;
            }
        },
        created: function () {
            let self = this;
            window.b = this;

            self.presentation_id = parseInt(self.$route.query.presentation_id);
            self.order_id = parseInt(self.$route.query.order_id);

            if (!self.Presentation) {
                self.$store.dispatch('GET', {silent: true, key: 'Presentations', id: self.presentation_id});
            }
            if (!self.Order) {
                self.$store.dispatch('DO', {
                    task: 'guest/orders',
                    data: {order_id: self.order_id},
                    callback: function (e) {
                        self.$store.commit('SET', {key: 'Orders', item: e});
                    }});
            }
        }
    }
</script>


// WEBPACK FOOTER //
// bank-return.vue?2f8ed0b7